/**
 * Created by guga on 8/19/2016.
 */

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { AuthSas }    from './auth.sas';
import { XhrSas }     from './xhr.sas';
import { Token }      from '../sas-models/token';
import { AuthState }  from '../sas-models/auth-state';
import { IXhrHeaders, IXhrOptions, IXhrResponse } from '../sas-models/xhr-types';

@Injectable()
export class AuthXhrSas {
    private _token : Token;

    public constructor(private _authSas : AuthSas, private _xhrSas : XhrSas) {
        this._authSas.authState$.map(
            (authState : AuthState) => authState.token
        ).subscribe(
            (token : Token) => this._token = token
        );
    }

    private _prepareHeaders(headers : IXhrHeaders) : IXhrHeaders {
        if (this._token!=null) {
            return Object.assign({}, headers, {"Authorization": "Bearer " + this._token.value});
        }
        else {
            return null;
        }
    }

    public get(path : string, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        return this._xhrSas.get(path, this._prepareHeaders(headers), options);
    }

    public post(path : string, data ?: any, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        return this._xhrSas.post(path, data, this._prepareHeaders(headers), options);
    }

    public postJson(path : string, data ?: string, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        let preparedHeaders : IXhrHeaders = Object.assign({}, this._prepareHeaders(headers), {"Content-Type" : "application/json"});
        return this._xhrSas.post(path, data, preparedHeaders, options);
    }

    public request(method : string, path : string, data : any, headers ?: IXhrHeaders, options ?: IXhrOptions) : Observable<IXhrResponse> {
        return this._xhrSas.request(method, path, data, this._prepareHeaders(headers), options);
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/auth-xhr.sas.ts